import { Link, Outlet, matchPath, useParams } from "react-router-dom";

import { SecondaryNavigation } from "@/components/secondary-navigation";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { useGetOrganisations } from "@/features/organisations/api/get-organisations";
import { NavigationGroup } from "@/types/navigation";

/**
 * Layout for viewing an organisation as a super admin
 */
export function SaOrganisationLayout() {
  const { id } = useParams();
  const { data: organisations } = useGetOrganisations();

  const navigation: NavigationGroup[] = [
    {
      elements: [
        { name: "Details", href: `/admin/organisations/${id}/overview` },
        {
          name: "Licence",
          href: `/admin/organisations/${id}/license`,
        },
        {
          name: "Users",
          href: `/admin/organisations/${id}/users`,
        },
        {
          name: "Invitations",
          href: `/admin/organisations/${id}/invitations`,
        },
        {
          name: "Sessions",
          href: `/admin/organisations/${id}/sessions`,
        },
        {
          name: "Tags",
          href: `/admin/organisations/${id}/tags`,
        },
        {
          name: "Event Categories",
          href: `/admin/organisations/${id}/event-categories`,
        },
      ],
    },
  ];

  const isSuperAdminUsersView =
    matchPath("/admin/organisations/:orgId/users", location.pathname) !== null;

  const isSuperAdminUserView =
    matchPath(
      "/admin/organisations/:orgId/users/:userId",
      location.pathname,
    ) !== null;

  return (
    <div>
      <Breadcrumb className="mb-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/admin/organisations">Organisations</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to={`/admin/organisations/${id}/overview`}>
                {organisations?.find((org) => org.id === id)?.name}
              </Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          {(isSuperAdminUsersView || isSuperAdminUserView) && (
            <>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to={`/admin/organisations/${id}/users`}>Users</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
            </>
          )}
          {isSuperAdminUserView && (
            <>
              <BreadcrumbSeparator />
              <BreadcrumbItem>Edit User</BreadcrumbItem>
            </>
          )}
        </BreadcrumbList>
      </Breadcrumb>
      <div className="grid grid-cols-12 gap-x-8">
        <div className="hidden md:col-span-3 md:block">
          <SecondaryNavigation navigations={navigation} />
        </div>
        <div className="col-span-12 md:col-span-9">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
